import React, {ReactNode} from "react";
import { View, Text, StyleSheet, ViewStyle } from "react-native";
import { LinearGradient } from "expo-linear-gradient";


type GradientBorderBoxProps = {
  children: ReactNode;
  style?: ViewStyle | ViewStyle[];
};
export default function GradientBorderBox({children}:GradientBorderBoxProps) {
  return (
    <LinearGradient
      colors={["#FEDB8D", "#FF8C00"]} // your gradient colors
      style={styles.gradientBorder}
    >
      <View style={styles.innerBox}>
        {children}
        {/* <Text style={{ color: "#000" }}>Hello Gradient Border</Text> */}
      </View>
    </LinearGradient>
  );
}

const styles = StyleSheet.create({
  gradientBorder: {
    padding: 2,              // border thickness
    borderRadius: 6,
  },
  innerBox: {
    backgroundColor: "#fff", // inner background
    alignItems: "center",
    // borderWidth: 1,
    paddingHorizontal: 26,
    paddingVertical: 12,
    borderRadius: 6,
  },
});